import { render, staticRenderFns } from "./AppDiseaseChip.vue?vue&type=template&id=02d46307&scoped=true&"
import script from "./AppDiseaseChip.vue?vue&type=script&lang=ts&"
export * from "./AppDiseaseChip.vue?vue&type=script&lang=ts&"
import style0 from "./AppDiseaseChip.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AppDiseaseChip.vue?vue&type=style&index=1&id=02d46307&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d46307",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
